import {useMemo, useState} from "react";
import ModalRoot from "../components/modal_root";
import {useNoWindowScroll} from "./hooks";

let nextKey = 1;

const pop = (stack) => stack.slice(0, stack.length - 1);
const push = (item) => (stack) => [...stack, item];
const dropAfter = (key) => (stack) => {
    const index = stack.findIndex((layer) => layer.key === key);
    return index === -1 ? stack : stack.slice(0, index);
};
const seq = (...fs) => (val) => {
    for (const f of fs) {
        val = f(val);
    }
    return val;
};
const newLayer = (setStack, Component, props, resolve) => {
    const key = nextKey;
    nextKey++;
    const onClose = (value) => {
        setStack(dropAfter(key));
        resolve(value);
    };
    return {key, Component, props, onClose};
};

export const useModalStack = () => {
    const [stack, setStack] = useState([]);
    const api = useMemo(() => ({
        close() {
            setStack(pop);
        },
        open(Component, props = {}) {
            return new Promise((resolve, reject) => {
                try {
                    setStack(seq(pop, push(newLayer(setStack, Component, props, resolve))));
                } catch (error) {
                    reject(error);
                }
            })
        },
        push(Component, props = {}) {
            return new Promise((resolve, reject) => {
                try {
                    setStack(push(newLayer(setStack, Component, props, resolve)));
                } catch (error) {
                    reject(error);
                }
            })
        },
    }), [setStack]);
    useNoWindowScroll(stack.length > 0);
    const element = <>{stack.map(({key, Component, props, onClose}, index) =>
        <ModalRoot key={key} visible={index === stack.length - 1}>
            <Component {...props} onClose={onClose}/>
        </ModalRoot>
    )}</>;
    return [element, api];
};
